module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.getUserAgree) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "modal-box"
  }, [_c('div', {
    staticClass: "context",
    on: {
      "click": _vm.closeModal
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal"
  }, [_c('img', {
    staticClass: "modal-close",
    attrs: {
      "src": require("../../assets/close.png")
    },
    on: {
      "click": _vm.closeModal
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('h4', {
    staticClass: "user-agree-title"
  }, [_vm._v("真相搜索用户使用协议与隐私条款")]), _vm._v(" "), _c('p', {
    staticClass: "user-agree-explain"
  }, [_vm._v("真相科技提醒您：在使用真相搜索或取证服务前，请您务必仔细阅读并透彻理解本声明。您可以选择不使用真相搜索取证平台，但如果您使用真相搜索取证平台，您的使用行为将被视为对本声明全部内容的认可。")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("鉴于真相搜索取证平台搜索功能以非人工检索方式、根据您键入的关键字自动生成到第三方网页的链接，除平台注明之服务条款外，其他一切因使用真相搜索取证平台搜索功能而可能遭致的意外、疏忽、侵权及其造成的损失（包括因下载被搜索链接到的第三方网站内容而感染电脑病毒），平台对其概不负责，亦不承担任何法律责任。")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("任何通过使用真相搜索取证平台而搜索链接到的第三方网页均系他人制作或提供，您可能从该第三方网页上获得资讯、享用服务、进行取证，真相搜索取证平台对其合法性概不负责，亦不承担任何法律责任。")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("真相搜索取证平台的搜索结果根据您键入的关键字自动搜索获得并生成，不代表真相搜索取证平台赞成被搜索链接到的第三方网页上的内容或立场。")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("您应该对使用搜索引擎的结果自行承担风险。真相搜索取证平台不做任何形式的保证：不保证搜索结果满足您的要求，不保证搜索服务不中断，不保证搜索结果的安全性、正确性、及时性、合法性。因网络状况、通讯线路、第三方网站等任何原因而导致您不能正常使用真相搜索，真相搜索不承担任何法律责任。")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("真相搜索取证平台尊重并保护所有使用真相搜索用户的个人隐私权，您注册的用户名、电子邮件地址等个人资料，非经您亲自许可或根据相关法律、法规的强制性规定，真相搜索不会主动地泄露给第三方。真相科技提醒您：您在使用搜索引擎时输入的关键字将不被认为是您的个人隐私资料。")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("用户在真相搜索取证平台所取证的任何内容并不代表和反映真相搜索取证平台的任何观点或政策，在任何情况下，真相搜索取证平台均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因用户使用平台服务而遭受的利润损失承担责任。")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("用户无需用户账户即可浏览本平台。但某些平台功能、取证产品、程序和服务需要您注册取证平台帐户。如果您想使用本平台的取证、程序和服务的更多功能，您必须注册相应帐户并且于注册页面上提供相关的个人信息。您可以按照网站说明随时终止使用您的账户，本平台将会依据本协议规定保留或终止您的账户。您必须承诺和保证：")]), _vm._v(" "), _c('p', {
    staticClass: "sub-item"
  }, [_vm._v("您了解并同意，本平台是一个为用户提供数据权益保护支持的【应用服务产品】，用户须对注册信息的真实性、合法性、有效性承担全部责任；用户不得冒充他人；不得恶意使用注册帐户导致其他用户误认；否则真相搜索取证平台有权立即停止提供服务，您独自承担由此而产生的一切法律责任。")]), _vm._v(" "), _c('p', {
    staticClass: "sub-item"
  }, [_vm._v("您使用本平台的搜索取证产品、程序及服务的行为必须合法，您必须为自己注册帐户下的一切行为负责。用户应对其中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。真相科技无法且不会对因用户行为而导致的任何损失或损害承担责任。")]), _vm._v(" "), _c('p', {
    staticClass: "sub-item"
  }, [_vm._v("您对您的登录信息保密、不被其他人获取并使用并且对您在本平台账户下的所有行为负责。您必须将任何有可能触犯法律的，未授权使用或怀疑为未授权使用的行为在第一时间通知本网站，本平台不对您因未能遵守上述要求而造成的损失承担责任。")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("您必须知悉并确认：")]), _vm._v(" "), _c('p', {
    staticClass: "sub-item"
  }, [_vm._v("真相搜索取证平台因业务发展需要，单方面对本服务的全部或部分服务内容在任何时候不经任何通知的情况下变更、暂停、限制、终止或撤销真相搜索取证平台服务的权利，用户需承担此风险。")]), _vm._v(" "), _c('p', {
    staticClass: "sub-item"
  }, [_vm._v("真相搜索取证平台提供的服务中可能包括广告等活动，用户同意在使用过程中显示真相搜索取证平台及关联方与第三方供应商、合作伙伴提供的广告以及其他活动。")]), _vm._v(" "), _c('p', {
    staticClass: "sub-item"
  }, [_vm._v("真相搜索取证平台的某些产品服务必须在联网的情况下才可以使用，包括但不限于：搜索平台、取证平台、IP360平台等。您必须自行负担个人上网或第三方（包括但不限于电信或移动通讯提供商）收取的通讯费、信息费等相关费用。如涉及电信增值服务，真相搜索取证平台建议您与增值服务提供商确认相关费用问题。")])])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9f020e9c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/others/UserAgree.vue
// module id = 777
// module chunks = 1